import React, { useState, useEffect, useContext, useRef, useCallback } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import AuthContext from '../../context/AuthContext';
import { FaCopy, FaUserSlash, FaUserPlus, FaMinus} from 'react-icons/fa'; 
import socket from '../../socket';

const AdminStatisticsPage = ({ setActiveTab, userCount }) => {
    const [allSubs, setAllSubs] = useState([]);
    
    useEffect(() => {
        const processData = async () => {
            const response = await axios.get(`${process.env.REACT_APP_API_URL_LOCAL}/api/stripe/get-all-subscriptions`);
            // console.log(response.data);
        }
        processData();
    }, [])
    return (
        <div>
            {userCount} active users
        </div>
    );
};

export default AdminStatisticsPage


//list of all the users (options to manually verify and unverify user accounts), ability to promote admins, 